import React from 'react';
import { getSetColorClass, getSetColorLabel } from '../../utils/colors';

interface SetIndicatorProps {
  label: string;
  value: number;
  target: number;
  inverse?: boolean;
  unit?: string;
  tooltip?: string;
}

// ===== Composant SetIndicator =====
const SetIndicator: React.FC<SetIndicatorProps> = ({
  label,
  value,
  target,
  inverse = false,
  unit = '%',
  tooltip,
}) => {
  const colorClass = getSetColorClass(value, target, inverse);
  const statusLabel = getSetColorLabel(value, target, inverse);

  return (
    <div
      className={`set-indicator ${colorClass}`}
      title={tooltip || `${label}: ${statusLabel}`}
    >
      <div className="set-indicator-label">
        {label}
        {tooltip && (
          <i
            className="fas fa-info-circle ml-2 text-sm opacity-70 cursor-help"
            title={tooltip}
          ></i>
        )}
      </div>
      <div className="flex items-center gap-3">
        <span className="set-indicator-value">
          {value.toFixed(1)}{unit}
        </span>
        <span className="set-indicator-target">
          Objectif: {target}{unit}
        </span>
        <span className="text-sm font-medium">
          {statusLabel}
        </span>
      </div>
    </div>
  );
};

export default SetIndicator;
